var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "conversation-list-item d-flex align-center pa-2",
      style: {
        backgroundColor: _vm.selected ? _vm.selectedBgColor : "",
        borderLeft: _vm.selected
          ? "2px solid var(--primary)"
          : "2px solid transparent"
      },
      attrs: { "data-test": "conversation-item" },
      on: {
        click: function($event) {
          return _vm.$emit("click", _vm.conversa)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "avatar-wrapper mr-2",
          staticStyle: { position: "relative" }
        },
        [
          _c(
            "v-avatar",
            {
              attrs: {
                size: "32",
                color: _vm.isGroup ? "blue-grey lighten-3" : "grey lighten-2"
              }
            },
            [
              _vm.contactFotoUrl
                ? _c("img", {
                    attrs: { src: _vm.contactFotoUrl, alt: _vm.contactName }
                  })
                : _vm.isGroup
                ? _c("icon-svg", {
                    attrs: {
                      name: _vm.icons.accountGroup,
                      size: "18",
                      color: "white",
                      "data-test": "group-icon"
                    }
                  })
                : _c("span", { staticClass: "az-text-small" }, [
                    _vm._v(_vm._s(_vm.contactName.charAt(0)))
                  ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "flex-grow-1 overflow-hidden" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-space-between align-center" },
          [
            _c(
              "div",
              {
                staticClass: "text-truncate",
                attrs: {
                  title:
                    _vm.contactName +
                    (_vm.whatsappName ? " (" + _vm.whatsappName + ")" : "")
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "az-text-primary az-size-14 font-medium" },
                  [_vm._v(" " + _vm._s(_vm.contactName) + " ")]
                ),
                _vm.whatsappName
                  ? _c("span", { staticClass: "az-text-small ml-1" }, [
                      _vm._v(" (" + _vm._s(_vm.whatsappName) + ") ")
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "span",
              { staticClass: "az-text-small az-muted ml-2 flex-shrink-0" },
              [_vm._v(" " + _vm._s(_vm.lastMessageTime) + " ")]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "preview-row d-flex justify-space-between align-center mt-1"
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "az-text-small text-truncate d-inline-flex align-center",
                class: _vm.isLastMessageNote ? "note-preview" : "az-muted",
                attrs: { title: _vm.fullMessagePreview }
              },
              [
                _vm.isLastMessageNote
                  ? _c("icon-svg", {
                      staticClass: "mr-1",
                      attrs: {
                        name: _vm.icons.noteIndicator,
                        size: "10",
                        color: "amber darken-2"
                      }
                    })
                  : _vm._e(),
                _c("span", {
                  staticClass: "text-truncate",
                  domProps: { innerHTML: _vm._s(_vm.lastMessagePreviewHtml) }
                })
              ],
              1
            ),
            _vm.hasUnread
              ? _c(
                  "span",
                  {
                    staticClass: "unread-badge ml-2 flex-shrink-0",
                    attrs: { "data-test": "unread-badge" }
                  },
                  [_vm._v(" " + _vm._s(_vm.unreadCount) + " ")]
                )
              : _vm._e()
          ]
        ),
        _vm.showConexaoChip
          ? _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c(
                  "v-chip",
                  {
                    attrs: {
                      "x-small": "",
                      color: _vm.$setOpacity(_vm.conexaoChipColor, 0.15),
                      "text-color": _vm.conexaoChipColor,
                      "data-test": "conexao-chip"
                    }
                  },
                  [
                    _c("icon-svg", {
                      staticClass: "mr-1",
                      attrs: {
                        name: _vm.icons.connections,
                        size: "10",
                        color: _vm.conexaoChipColor
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.conexaoNome) + " ")
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.hasAssigned
          ? _c(
              "div",
              {
                staticClass: "d-flex align-center mt-1",
                attrs: { "data-test": "assigned-info" }
              },
              [
                _c("icon-svg", {
                  staticClass: "mr-1",
                  attrs: { name: _vm.icons.account, size: "10", color: "grey" }
                }),
                _c(
                  "span",
                  { staticClass: "az-text-small az-muted text-truncate" },
                  [_vm._v(" " + _vm._s(_vm.assignedToName) + " ")]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }